import Tooltip from '@mui/material/Tooltip';
import { config } from '../../../../services/config'
import { Typography } from '@mui/material';
import { Grid } from "@mui/material";
export function OrderInfoIcons({ order }) {

  return (
    <Grid container spacing={1}>
      {
      (order.fechaEntrega) && 
      <Grid item><Tooltip title={"Se entrega: " + order.fechaEntrega}><Typography variant='h6'>🕓</Typography></Tooltip></Grid>
      }
      {
      (order.estado === 0) && 
      <Grid item><Tooltip title="Esta Orden necesita aprobacion"><Typography variant='h6'>🔥</Typography></Tooltip></Grid>
      }
      {
      (order.condicionVenta === config.condicionVtaBiocook) && 
      <Grid item><Tooltip title="Esta Orden se factura en BioCook"><Typography variant='h6'>💳</Typography></Tooltip></Grid>
      }
      {
      (order.pagado !== 0) && 
      <Grid item><Tooltip title="Pago registrado"><Typography variant='h6'>🏁</Typography></Tooltip></Grid>
      }
      
    </Grid>
  )
}